import { getBranding, sharedColors } from "../../../../Themes/allThemes";
import { colors } from "@storeblocks/global-styles";
import styled from "styled-components";
export const Wrapper = styled.div `
  align-items: center;
  align-content: center;
  display: flex;
  justify-content: space-between;
  margin-top: ${(props) => (props.hasSubTitle ? "5px" : "11px")};
  width: 100%;

  & a {
    margin: 0 10px;
  }
`;
export const LineWrapper = styled.div `
  flex-grow: 1;
  display: grid;
`;
export const HorizontalLine = styled.div `
  background: ${(props) => props.active
    ? getBranding(props.branding).verticalLineBackground
    : colors.grey.grey40};
  height: ${(props) => (props.active ? "3px" : "1px")};
`;
export const Title = styled.div `
  max-width: 100%;
  overflow-wrap: break-word;
  ${(props) => props.isMobileLayout && "margin-right: 20px;"}
`;
export const SubTitle = styled.div `
  color: ${sharedColors.black};
  display: block;
  font-size: 14px;
  margin-top: 8px;
  width: 100%;
  max-width: 100%;
  overflow-wrap: break-word;
`;
//# sourceMappingURL=styled.js.map